module.exports = __webpack_public_path__ + "img/pic-HaiwenZhou.5d39c58b.png";